import { authGuard, guestGuard } from './utils'

export default [

    ...authGuard([
        { path: '/', name: 'home', component: require('@/pages/Settings.vue').default },
        { path: '/profile', name: 'profile', component: require('@/pages/Profile.vue').default },
        { path: '/places', name: 'places', component: require('@/pages/Places.vue').default },
        { path: '/cities', name: 'cities', component: require('@/pages/Cities.vue').default },
        { path: '/artists', name: 'artists', component: require('@/pages/Artists.vue').default },
        { path: '/artistcategories', name: 'artistcategories', component: require('@/pages/ArtistCategories.vue').default },
        { path: '/programs', name: 'programs', component: require('@/pages/Programs.vue').default },
        { path: '/media', name: 'media', component: require('@/pages/Media.vue').default },
        { path: '/posts', name: 'posts', component: require('@/pages/Posts.vue').default },
        { path: '/posts/edit/:id', name: 'postseditor', component: require('@/pages/PostEditor.vue').default },
        { path: '/posts/create', name: 'postscreator', component: require('@/pages/PostEditor.vue').default },
        { path: '/pages/edit/:id', name: 'pageditor', component: require('@/pages/PageEditor.vue').default },
        { path: '/pages/create', name: 'pagecreator', component: require('@/pages/PageEditor.vue').default },
        { path: '/postcategories', name: 'postcategories', component: require('@/pages/PostCategories.vue').default },
        { path: '/wishlists', name: 'wishlists', component: require('@/pages/Wishlist.vue').default },
        { path: '/wishlistcategories', name: 'wishlistcategories', component: require('@/pages/WishlistCategories.vue').default },
        { path: '/subscribers', name: 'subscribers', component: require('@/pages/Subscribers.vue').default },
        { path: '/users', name: 'users', component: require('@/pages/Users.vue').default },
        { path: '/galleries', name: 'galleries', component: require('@/pages/Galleries.vue').default },
        { path: '/galleries/edit/:id', name: 'gallerieseditor', component: require('@/pages/GalleryEditor.vue').default },
        { path: '/galleries/create', name: 'galleriescreator', component: require('@/pages/GalleryEditor.vue').default },
        { path: '/news', name: 'news', component: require('@/pages/News.vue').default },
        { path: '/news/edit/:id', name: 'newseditor', component: require('@/pages/NewsEditor.vue').default },
        { path: '/news/create', name: 'newscreator', component: require('@/pages/NewsEditor.vue').default },
        { path: '/settings', name: 'settings', component: require('@/pages/Settings.vue').default },
        { path: '/menus', name: 'menus', component: require('@/pages/Menus.vue').default },
        { path: '/guides', name: 'guides', component: require('@/pages/Guides.vue').default },
        { path: '/pages', name: 'pages', component: require('@/pages/Pages.vue').default },
        { path: '/supportercategories', name: 'supportercategories', component: require('@/pages/SupporterCategories.vue').default },
        { path: '/supporters', name: 'supporters', component: require('@/pages/Supporters.vue').default },
        { path: '/sliders', name: 'sliders', component: require('@/pages/Sliders.vue').default },
        { path: '/tickets', name: 'tickets', component: require('@/pages/Tickets.vue').default },
        { path: '/middletile', name: 'middletile', component: require('@/pages/MiddleTile.vue').default },
        { path: '/forms', name: 'forms', component: require('@/pages/Forms.vue').default },
        { path: '/recommendations', name: 'recommendations', component: require('@/pages/Recommendations.vue').default },
        { path: '/buses', name: 'buses', component: require('@/pages/Buses.vue').default },
        { path: '/routes', name: 'routes', component: require('@/pages/Routes.vue').default },
        { path: '/stations', name: 'stations', component: require('@/pages/Stations.vue').default },
        { path: '/trackers', name: 'trackers', component: require('@/pages/Trackers.vue').default },
        { path: '/trackermap', name: 'trackermap', component: require('@/pages/TrackerMap.vue').default },
        { path: '/timetable', name: 'timetable', component: require('@/pages/Timetable.vue').default },
        { path: '/notifications', name: 'notifications', component: require('@/pages/Notifications.vue').default },
        { path: '/mainpage', name: 'mainpage', component: require('@/pages/MainPage.vue').default },
        { path: '/mainpageimages', name: 'mainpageimages', component: require('@/pages/MainPageImages.vue').default },
        { path: '/programcategories', name: 'programcategories', component: require('@/pages/ProgramCategories.vue').default },
        { path: '/sitenotifications', name: 'sitenotifications', component: require('@/pages/SiteNotifications.vue').default },
        { path: '/contactpeople', name: 'contactpeople', component: require('@/pages/ContactPeople.vue').default },
        { path: '/questions', name: 'questions', component: require('@/pages/Questions.vue').default },

    ]),

    ...guestGuard([
        { path: '/login', name: 'login', component: require('@/pages/Login.vue').default },
    ]),

    { path: '*', component: require('@/pages/NotFound.vue').default },
]



// WEBPACK FOOTER //
// ./src/router/routes.js